<template>
  <div>
    <div
      v-for="group in availableCategories"
      :key="group.label">

      <h5>
        {{ $t(group.label) }}
      </h5>
      <div class="row m-0 mb-3">
        <div
          :class="`col-md-4 ${getCategoryClass(category.connected)} category-item`"
          v-for="category in group.options"
          :key="category.name"
          :data-v-step="`campaign.create.category.${category.number}`">

          <campaign-pholder
            :connectable="category.connected"
            :site="category"
            @selectCategory="selectCategory" />

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import availableItems from '@/assets/configurations/avalableItems'
import CategoryPholder from '@/components/service/campaignManager/CategoryPholder'

export default {
  data () {
    return {
      availableCategories: availableItems.campaign.availableCategories
    }
  },

  methods: {
    selectCategory (e) {
      if (!e.selected) return;

      let { route = 'createCampaign', name: category } = e
      this.$router.push({
        name: route,
        params: { category }  
      })
    },
    getCategoryClass (connected) {
      return connected ? 'enabled' : 'dissabled'
    }
  },
  components: {
    'campaign-pholder': CategoryPholder
  }
}
</script>

<style scoped>
.card-text {
  height: 55px;
  overflow-y: scroll;
}
.category-item {
  padding: 9px;
}
.enabled.category-item {
  cursor: pointer;
}

@media (max-width: 768px) {
  .category-item {
    padding: 2.5px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/service/campaignManager/CampaignCategory.vue?3496369a